import React from 'react';
import TypoTranslateViewer from './typo/TypoTranslateViewer';
import ColorFontViewer from './colorFont/ColorFontViewer';

/**
 * PPT 검사 탭 콘텐츠 컴포넌트
 * 탭 메뉴는 App.js 헤더에서 관리, 여기서는 탭 내용만 렌더링
 */
const PPTCheckTabs = ({
  activeTab,
  slides = [],
  onModalOpen,
  // 색상 관련 props
  colors,
  allSlidesColorResults,
  colorCheckStatus,
  isAnalyzing,
  checkProgress,
  analyzeAllSlidesColors,
  handleResultThumbnailClick,
  // 폰트 관련 props
  fonts,
  allSlidesFontResults,
  fontCheckStatus,
  isFontAnalyzing,
  fontCheckProgress,
  analyzeAllSlidesFonts,
  handleFontResultThumbnailClick,
  // 번역 관련 props
  isTranslating,
  translateProgress,
  translateStatus,
  translatedLanguages,
  translateAndDownloadPPT,
  // PDF for typo result modal
  pdfUrl,
  pdfDoc,
  setPdfDoc,
  // 알림창 표시 함수
  showAlertModal,
  showConfirmModal,
  // 폰트 변경 콜백
  onFontChange,
  // 모바일 여부
  isMobile,
  // 오타 결과 모달 상태
  showTypoResultModal,
  setShowTypoResultModal,
  selectedPpt,
  // 썸네일 lazy loading
  loadThumbnailsForSlide,
  // 오타 위치 매칭용 슬라이드 크기
  typoSlideSize,
  // 오타 임시저장 콜백
  onSaveTypoDraft,
  // 오타 draft 존재 여부
  hasTypoDraft,
  // 오타 draft 적용/초기화 함수
  loadedTypoDraft,
  applyTypoDraft,
  clearTypoDraft,
  ...props
}) => {
  return (
    <>
      {/* 탭 내용만 렌더링 (탭 메뉴는 App.js 헤더에서 관리) */}
      {activeTab === 'typo' && (
        <TypoTranslateViewer
          tabType="typo"
          {...props}
          slides={slides}
          pdfUrl={pdfUrl}
          pdfDoc={pdfDoc}
          setPdfDoc={setPdfDoc}
          isMobile={isMobile}
          showTypoResultModal={showTypoResultModal}
          setShowTypoResultModal={setShowTypoResultModal}
          selectedPpt={selectedPpt}
          typoSlideSize={typoSlideSize}
          onSaveTypoDraft={onSaveTypoDraft}
          hasTypoDraft={hasTypoDraft}
          loadedTypoDraft={loadedTypoDraft}
          applyTypoDraft={applyTypoDraft}
          clearTypoDraft={clearTypoDraft}
          showAlertModal={showAlertModal}
          showConfirmModal={showConfirmModal}
        />
      )}

      {activeTab === 'color' && (
        <ColorFontViewer
          tabType="color"
          slides={slides}
          onModalOpen={onModalOpen}
          items={colors}
          allSlidesResults={allSlidesColorResults}
          checkStatus={colorCheckStatus}
          isAnalyzing={isAnalyzing}
          checkProgress={checkProgress}
          analyzeFunction={analyzeAllSlidesColors}
          handleResultThumbnailClick={handleResultThumbnailClick}
          showAlertModal={showAlertModal}
          isMobile={isMobile}
          loadThumbnailsForSlide={loadThumbnailsForSlide}
        />
      )}

      {activeTab === 'font' && (
        <ColorFontViewer
          tabType="font"
          slides={slides}
          onModalOpen={handleFontResultThumbnailClick}
          items={fonts}
          allSlidesResults={allSlidesFontResults}
          checkStatus={fontCheckStatus}
          isAnalyzing={isFontAnalyzing}
          checkProgress={fontCheckProgress}
          analyzeFunction={analyzeAllSlidesFonts}
          handleResultThumbnailClick={handleFontResultThumbnailClick}
          showAlertModal={showAlertModal}
          showConfirmModal={showConfirmModal}
          onFontChange={onFontChange}
          isMobile={isMobile}
          loadThumbnailsForSlide={loadThumbnailsForSlide}
        />
      )}

      {activeTab === 'translate' && (
        <TypoTranslateViewer
          tabType="translate"
          {...props}
          slides={slides}
          isTranslating={isTranslating}
          translateProgress={translateProgress}
          translateStatus={translateStatus}
          translatedLanguages={translatedLanguages}
          translateAndDownloadPPT={translateAndDownloadPPT}
          isMobile={isMobile}
        />
      )}
    </>
  );
};

export default PPTCheckTabs;
